import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { QueryTagService } from '@digilize/shared/utils/services/src';

@Component({
  selector: 'suc-research-query-table',
  templateUrl: './research-query-table.component.html',
  styleUrls: ['./research-query-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ResearchQueryTableComponent implements OnInit {
  @ViewChild('tableContainer') tableContainer: ElementRef<HTMLElement>;
  _tableHtml: SafeHtml;
  @Input() set tableHtml(html: string) {
    this._tableHtml = this.sanitizer.bypassSecurityTrustHtml(html);
  }

  _tableData: Object;
  @Input() set tableData(tableData: Object) {
    this._tableData = tableData;
    if (this._tableData) {
      setTimeout(() => {
        this.setTableData();
      }, 0);
    }
  }
  constructor(
    private sanitizer: DomSanitizer,
    private queryTagService: QueryTagService
  ) {}

  ngOnInit(): void {}

  setTableData(): void {
    const tableContainer = this.tableContainer.nativeElement;
    if (!tableContainer) {
      throw Error('Table tag not found in section');
    }
    const tags = tableContainer.getElementsByTagName('tag');
    Array.from(tags).forEach(
      (tag) => (tag.innerHTML = this.queryTagService.getTagInnerHTMLFromAttributes(this._tableData, tag))
    );
  }
}
